export function setToGraded(question) {	
	const oldChoices=question.choices
	let newChoices=[]

	oldChoices.map(function(choice,i){
		let isCorrect=false
		if(i===0){
	  	isCorrect=true
		} 
		const newChoice={
			body:choice.body,
			correct:isCorrect,
		}
		newChoices.push(newChoice)
		return null
	})
	question.choices=newChoices
	return question
}





